// Modules
import React from "react";

const PageLoading = () => {
    return (
        <div className="loading-page-container">
            <span className="wk-spin wk-icon-spinner"></span>
        </div>
    );
};

export default PageLoading;
